module.exports = __webpack_public_path__ + "img/shop.1bf34e6a.png";